export default "__VITE_ASSET__C0VfJ9VT__"